module.exports = __webpack_public_path__ + "static/img/statusCorrectTom.ae1a0767.gif";